// Fetches CSRF token using Axios; sets it in a cookie for secure API requests.
// Includes error handling.

import { axiosLevelTech } from './axiosConfig';
import { setupJqueryOverides } from '@/classic/JqueryOverrides'; //import jquery overrides
import { App } from '@capacitor/app'
import { isMobileApp } from './mobile_app/mobileAppServices';
import { Preferences } from '@capacitor/preferences';

/**
 * Extracts the JWT token from the browser cookies.
 * @returns The JWT token if found, otherwise undefined.
 */
export const getJwtToken = async (): Promise<string | undefined> => {
    const jwtToken = await Preferences.get({ key : 'tokenV1'});
    if (jwtToken && jwtToken.value) {
        return jwtToken.value;
    }else{
        let oldjwtToken = localStorage.getItem('tokenV1');

        if (oldjwtToken) {
            await Preferences.set({ key : 'tokenV1', value : oldjwtToken });
            localStorage.removeItem('tokenV1');
            return oldjwtToken;
        }
    }
};

export async function fetchCsrfToken() {
    try {
        if (document.cookie.split('; ').find((row) => row.startsWith('XSRF-TOKEN='))) {
            return;
        }
        const response = await axiosLevelTech.get('/sanctum/csrf-cookie');
        // console.groupCollapsed('CSRF Token Fetch');
        // console.log('Fetched:', response);
        // console.groupEnd();
    } catch (error) {
        // console.groupCollapsed('Error Fetching CSRF Token');
        // console.error(error);
        // console.groupEnd();
        // Consider additional error handling strategies here, like retrying the fetch
    }
}

export async function initializeApiServices() {
    try {

        App.addListener('appStateChange', ({ isActive }) => {
            if (isActive) {
                // console.log('App resumed, fetching XSRF token...');
                initTokens();
            }else{
                // console.log('App sent to background.');
            }
        })

        initTokens();
        
        
        // Add any additional API initialization tasks here
    } catch (error) {
        // console.groupCollapsed('Error Initializing API Services');
        // console.error(error);
        // console.groupEnd();
        // Consider how to propagate this error to the user or application
    }
}

export async function initTokens(){
    // Check if the CSRF token is already set in a cookie
        // if not, fetch it and use it.
        let csrfTokenCookie = document.cookie.split('; ').find((row) => row.startsWith('XSRF-TOKEN='));
        let csrfToken = null;
        if (csrfTokenCookie) {
            csrfToken = decodeURIComponent(csrfTokenCookie.split('=')[1]);
        } else {
            await fetchCsrfToken();
            csrfTokenCookie = document.cookie.split('; ').find((row) => row.startsWith('XSRF-TOKEN='));
            if (csrfTokenCookie) {
            csrfToken = decodeURIComponent(csrfTokenCookie!.split('=')[1]);
            }
        }

        let jwtToken = await getJwtToken();

        const baseUrl = process.env.NODE_ENV === 'production' ? `${import.meta.env.VITE_LEVEL_TECH_API_URL}/api/classic/` : `${import.meta.env.VITE_LOCAL_LEVEL_TECH_API_URL}/api/classic/`;
        // console.log('csrfToken:', csrfToken);
        // console.log('jwtToken:', jwtToken);
        setupJqueryOverides(baseUrl, csrfToken!, jwtToken!);
}

export function getCookieValue(name: string) {
    const regex = new RegExp(`(^| )${name}=([^;]+)`);
    const match = document.cookie.match(regex);
    if (match) {
      return decodeURIComponent(match[2]);
    }
  }